import React, { useEffect, useRef } from 'react';

const CanvasClock = () => {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);

  const degToRad = (degree) => {
    var factor = Math.PI / 180;
    return degree * factor;
  };

  const renderTime = (ctx, scale) => {
    var now = new Date();
    var today = now.toDateString();
    var hour = now.getHours();
    hour = hour > 9 ? hour : "0" + hour;
    var minute = now.getMinutes();
    minute = minute > 9 ? minute : "0" + minute;
    var second = now.getSeconds();
    var secondColor = second > 45 ? "red" : (second > 30 ? "yellow" : (second > 15 ? "#61dafb" : "#32CD32"));
    second = second > 9 ? second : "0" + second;

    var hours = now.getHours();
    var minutes = now.getMinutes();
    var seconds = now.getSeconds();
    var milliseconds = now.getMilliseconds();
    var newHours = hours + (minutes / 60);
    var newMinutes = minutes + (seconds / 60);
    var newSeconds = seconds + (milliseconds / 1000);

    ctx.save();
    ctx.scale(scale, scale);
    ctx.fillStyle = "#000000";
    ctx.clearRect(0, 0, 700, 700);

    // Re-apply styles after clear
    ctx.strokeStyle = '#61dafb';
    ctx.lineWidth = 20;
    ctx.lineCap = 'round';
    ctx.shadowBlur = 15;
    ctx.shadowColor = '#61dafb';

    ctx.beginPath();
    ctx.strokeStyle = '#000000';
    ctx.shadowColor = '#6C0BA9';
    ctx.arc(350, 300, 100, degToRad(270), degToRad(-99));
    ctx.stroke();
    ctx.arc(350, 300, 140, degToRad(270), degToRad(-99));
    ctx.stroke();
    ctx.arc(350, 300, 180, degToRad(270), degToRad(-90));
    ctx.stroke();

    // hour
    ctx.beginPath();
    ctx.strokeStyle = '#61dafb';
    ctx.shadowColor = '#61dafb';
    ctx.arc(350, 300, 100, degToRad(270), degToRad((newHours * 30) - 90));
    ctx.stroke();

    // minutes
    ctx.beginPath();
    ctx.strokeStyle = '#61dafb';
    ctx.shadowColor = '#61dafb';
    ctx.arc(350, 300, 140, degToRad(270), degToRad((newMinutes * 6) - 90));
    ctx.stroke();

    // seconds
    ctx.beginPath();
    ctx.strokeStyle = '#32CD32';
    ctx.shadowColor = '#32CD32';
    ctx.arc(350, 300, 180, degToRad(270), degToRad(Math.min(newSeconds, 15) * 6 + 270));
    ctx.stroke();
    if (newSeconds > 15) {
      ctx.beginPath();
      ctx.strokeStyle = '#61dafb';
      ctx.shadowColor = '#61dafb';
      ctx.arc(350, 300, 180, degToRad(360), degToRad(Math.min(newSeconds, 30) * 6 + 270));
      ctx.stroke();
    }
    if (newSeconds > 30) {
      ctx.beginPath();
      ctx.strokeStyle = 'yellow';
      ctx.shadowColor = 'yellow';
      ctx.arc(350, 300, 180, degToRad(450), degToRad(Math.min(newSeconds, 45) * 6 + 270));
      ctx.stroke();
    }
    if (newSeconds > 45) {
      ctx.beginPath();
      ctx.strokeStyle = 'red';
      ctx.shadowColor = 'red';
      ctx.arc(350, 300, 180, degToRad(540), degToRad(newSeconds * 6 + 270));
      ctx.stroke();
    }

    // date
    ctx.font = "14px nunito";
    ctx.fillStyle = '#61dafb';
    ctx.shadowColor = '#61dafb';
    ctx.fillText(today, 293, 280);

    // time
    ctx.font = "bold 30px nunito";
    ctx.fillStyle = '#61dafb';
    ctx.shadowColor = '#000000';
    ctx.fillText(":", 320, 308);
    ctx.fillText(":", 369, 308);
    ctx.fillText(hour, 282, 310);
    ctx.fillText(minute, 332, 310);
    ctx.fillStyle = secondColor;
    ctx.fillText(second, 382, 310);

    // name
    ctx.font = "14px nunito";
    ctx.fillStyle = '#61dafb';
    ctx.shadowColor = '#61dafb';
    ctx.fillText("Krishnendu Addya", 290, 330);
    ctx.restore();
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    let animId;
    let currentScale = 1;

    const handleResize = () => {
      if (!containerRef.current) return;
      const containerWidth = containerRef.current.offsetWidth;
      const isMobile = window.innerWidth < 768;

      // Use window width for breakpoint, but scale based on the container
      const baseWidth = isMobile ? 420 : 700;
      currentScale = Math.min(containerWidth / baseWidth, isMobile ? 1.40 : 1);

      canvas.width = 700 * currentScale;
      canvas.height = 600 * currentScale;
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    const tick = () => {
      renderTime(ctx, currentScale);
      animId = requestAnimationFrame(tick);
    };

    animId = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div ref={containerRef} className="w-full flex justify-center overflow-hidden">
      <canvas ref={canvasRef} />
    </div>
  );
};

export default CanvasClock;
